var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Row',[_c('Col',{attrs:{"cols":"12"}},[_c('DomainHeading',{attrs:{"title":_vm.lc.title}})],1),_c('Col',{attrs:{"cols":"12"}},[_c('FaviconCard')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }